import { EventSourceHandler } from '@sellsy/sse';

export default class OcrCompletedEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'staff.ocr.completed';
    }

    handle(event) {
        EventBus.emit('ocr:completed', event.data);
    }
}
